// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'creatopolis-test',
    appId: '1:1051514845289:web:61c8aa0fce83d949bacaf8',
    storageBucket: 'creatopolis-test.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyDlhIWHEqX1LV8dNzUHLT9N7TxWWrGkHuM',
    authDomain: 'creatopolis-test.firebaseapp.com',
    messagingSenderId: '1051514845289',
    measurementId: 'G-22WV6ZE697',
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
